<template>
    <div v-if="client">
        <p class="title is-5">Taxes settings</p>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Rules</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <table class="table is-striped">
                        <tr>
                            <th>
                                <div class="button is-small" @click="sortRules">Order</div>
                            </th>
                            <th>Category</th>
                            <th>Provider</th>
                            <th>StakeTaxPercent</th>
                            <th>WinTaxPercent</th>
                            <th></th>
                        </tr>
                        <tr v-for="(rule, index) in client.settings.taxSettings.rules" :key="`rule-${index}`">
                            <td style="vertical-align: middle;">{{ getRuleOrder(rule) }}</td>
                            <td>
                                <div class="select">
                                    <select v-model="rule.category">
                                        <option :value="null">
                                            [any]
                                        </option>
                                        <option
                                        v-for="category in gameCategories"
                                        :key="category"
                                        :value="category">{{ category }}</option>
                                    </select>
                                </div>
                            </td>
                            <td>
                                <div class="select">
                                    <select v-model="rule.provider">
                                        <option :value="null">
                                            [any]
                                        </option>
                                        <option
                                        v-for="provider in gameProviders"
                                        :key="provider"
                                        :value="provider">{{ provider }}</option>
                                    </select>
                                </div>
                            </td>
                            <td><input v-model.number="rule.stakeTaxPercent" class="input" type="number" /></td>
                            <td><input v-model.number="rule.winTaxPercent" class="input" type="number" /></td>
                            <td><button class="button is-danger" @click="deleteRule(index)">Delete</button></td>
                        </tr>
                    </table>
                    <button class="button is-success" @click="addRule()">Add</button>
                </div>
            </div>
        </div>
        <div class="field-body">
            <div class="field is-grouped">
                <div class="control">
                    <button @click="save" class="button is-primary">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import state from '../../../../state';
import utils from '../../../../utils';

import clientService from '../../../../services/client.service';
import gameService from '../../../../services/game.service';

export default {
    data() {
        return {
            client: null,
            gameProviders: null,
            gameCategories: null,
        }
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId)
        }
    },
    watch: {
        clientId() {
            this.loadClient()
        }
    },
    async mounted() {
        await clientService.ensure()
        this.loadClient()
        await this.loadGameProviders()
        await this.loadGameCategories()
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async loadGameProviders () {
            this.gameProviders = await gameService.getGameProviders()
            this.gameProviders.sort((a, b) => a.localeCompare(b))
        },
        async loadGameCategories () {
            this.gameCategories = await gameService.getGameCategories(this.clientId)
            this.gameCategories.sort((a, b) => a.localeCompare(b))
        },
        async save() {
            await clientService.save(this.client);
        },
        getRuleOrder (rule) {
            if (rule.category && rule.provider) return 0
            if (rule.category) return 1
            if (rule.provider) return 2
            return 3
        },
        sortRules () {
            this.client.settings.taxSettings.rules.sort((a,b) => this.getRuleOrder(a) - this.getRuleOrder(b))
        },
        addRule () {
            if (!this.client.settings.taxSettings.rules) Vue.set(this.client.settings.taxSettings, 'rules', [])

            this.client.settings.taxSettings.rules.push({
                category: null,
                provider: null,
                stakeTaxPercent: 0,
                winTaxPercent: 0,
            })
        },
        deleteRule (index) {
            this.client.settings.taxSettings.rules.splice(index, 1)
        }
    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// front/src/components/clients/client/settings/taxes.vue